import { OpportunityContactView } from '@api-proxies';
import { CustomCellActionsComponent } from '@app/components/shared/grids/custom-cell-actions/custom-cell-actions.component';
import { CustomCellCompanyComponent } from '@app/components/shared/grids/custom-cell-company/custom-cell-company.component';
import { TabNames } from '@enums/TabNames';
import { ColDef, ICellRendererParams, ValueFormatterParams } from 'ag-grid-enterprise';

export const OPPORTUNITY_CONTACTS_GRID_COLUMNS: ColDef[] = [
    {
        colId: 'contactId',
        field: 'contactId',
        headerName: 'ID',
        width: 100,
        lockPinned: true,
        lockPosition: 'left',
        suppressSizeToFit: true,
        cellRenderer: (params: ICellRendererParams<OpportunityContactView>) => {
            if (params.value) {
                const link = `/contacts-single/${params.value}/${TabNames[TabNames.Overview]}`;
                return `<a class="anchor" href="${link}">${params.value}</a>`;
            }
            return '';
        }
    },
    {
        colId: 'fullName',
        field: 'fullName',
        headerName: 'Name',
        cellDataType: 'text',
        sortable: true
    },
    {
        colId: 'companyName',
        field: 'companyName',
        headerName: 'Company',
        cellDataType: 'text',
        sortable: true,
        cellRenderer: CustomCellCompanyComponent
    },
    {
        colId: 'buildingContactRoleNames',
        field: 'buildingContactRoleNames',
        headerName: 'Contact Roles',
        cellDataType: 'text',
        sortable: true
    },
    {
        colId: 'phone',
        field: 'phone',
        headerName: 'Phone',
        cellDataType: 'text',
        sortable: false,
        valueFormatter: (params: ValueFormatterParams<OpportunityContactView>) => {
            if (Array.isArray(params.value)) {
                return params.value.join(', ');
            }
            return params.value || '';
        }
    },
    {
        colId: 'email',
        field: 'email',
        headerName: 'Email',
        cellDataType: 'text',
        sortable: false,
        valueFormatter: (params: ValueFormatterParams<OpportunityContactView>) => {
            if (Array.isArray(params.value)) {
                return params.value.join(', ');
            }
            return params.value || '';
        }
    },
    {
        colId: 'lastContactDate',
        field: 'lastContactDate',
        headerName: 'Last Contact',
        cellDataType: 'date',
        sortable: true,
        valueFormatter: (params: ValueFormatterParams<OpportunityContactView>) => {
            if (!params.value) return '';
            const date = new Date(params.value);
            return date.toLocaleDateString();
        }
    },
    {
        colId: 'followUpDate',
        field: 'followUpDate',
        headerName: 'Follow up on',
        cellDataType: 'date',
        sortable: true,
        valueFormatter: (params: ValueFormatterParams<OpportunityContactView>) => {
            if (!params.value) return '';
            const date = new Date(params.value);
            return date.toLocaleString();
        }
    },
    {
        colId: 'actions',
        headerName: '',
        maxWidth: 80,
        sortable: false,
        filter: false,
        resizable: false,
        suppressHeaderMenuButton: true,
        suppressSizeToFit: true,
        cellRenderer: CustomCellActionsComponent,
        cellClass: 'action-cell'
    }
];
